export const FORM_TYPES = [
  { value: 1, label: 'Evaluación' },
  { value: 2, label: 'Sugerencias' },
  { value: 3, label: 'Contacto' },
];
